import React from 'react'

const DataFormatter = ({ children }) => {
    return (
        <>{children}</>
    )
}

export default DataFormatter